import React from "react";
import {Input, Tree, Icon, Empty} from "antd";
import "./CmTree.css";
import {Scrollbars} from "react-custom-scrollbars";
import TreeOperation from "./treeOperation/TreeOperation";
import {filterForEach, forEachTree} from "../../utils";
import $Jq from 'jquery'

const {TreeNode} = Tree;
const {Search} = Input;

export default class CmTree extends React.Component {

    static defaultProps = {
        disableKeys : [],
        isShowAddOperate: true
    };

    constructor(props) {
        super(props);
        this.state = {
            searchValue: "",
            isShowTree: true,
        };
    }

    render() {
        let {isShowTree} = this.state;
        let {
            treeData,
            autoExpandParent,

            selectedKeys,
            onSelect,
            expandedKeys,

            ExpandedIcon = <Icon style={{color: "#ffcd2c"}} type="folder-open" theme="filled"/>,
            ClosedIcon = <Icon style={{color: "#ffcd2c"}} type="folder" theme="filled"/>,
            itemIcon = <Icon type="file-text"/>,
            checkedKeys = [],
            checkable = false,
            checkStrictly,
            showIcon,
            showSearch,
            showTreeOperation,

            onTreeAdd,
            onTreeEdit,
            onTreeDelete,
            selectable = true,
            onCheck,
            isCheckAble,
            isSearch,
            visible,
            isMenuTree,
            onDisableAllDeptCall,
            isShowAddOperate
        } = this.props;

        let searchValue;
        if (!visible) {
            this.state.searchValue = "";
            this.state.isShowTree = true;
        }
        searchValue = this.state.searchValue;
        if (searchValue) {
            treeData = filterForEach(treeData, node => {
                return node.title.includes(searchValue);
            });
        }
        // 展示小图标？
        let TitleIcon;
        const loop = (data, root) => {
            return data.map(item => {
                if (showIcon) {
                    if (item.icon) {
                        TitleIcon = item.icon;
                    } else {
                        if (item.children && item.children.length) {
                            if (expandedKeys.includes(item.key)) {
                                TitleIcon = ExpandedIcon;
                            } else {
                                TitleIcon = ClosedIcon;
                            }
                        } else {
                            TitleIcon = itemIcon;
                        }
                    }

                    TitleIcon = <span style={{marginRight: 10}}>{TitleIcon}</span>;
                }

                // 复选框选中 颜色变化 的class
                let showCheckColor = " ";
                if (checkStrictly) {
                    // 上下级不关联
                    if (checkable && checkedKeys && checkedKeys.checked && checkedKeys.checked.includes(item.key)) {
                        showCheckColor = "check-color ";
                    }
                } else {
                    // console.log(checkedKeys,item.key);
                    if (checkable && checkedKeys.checked && checkedKeys.checked.includes(item.key)) {
                        showCheckColor = "check-color ";
                    }
                }

                const searchValueIndex = item.title.indexOf(searchValue);
                const beforeStr = item.title.slice(0, searchValueIndex);
                const afterStr = item.title.slice(searchValueIndex + searchValue.length);
                // 最终的展示 title
                let title = <div className="operateTitle-wrap">
                    {TitleIcon}
                    <span className={"title-text padding-right-10 " + showCheckColor}>
                        {
                            searchValueIndex > -1 ?
                                <span>
                                    {beforeStr}
                                    <span className="search-value-color">{searchValue}</span>
                                    {afterStr}
                                    {
                                        isMenuTree ? <span>——{item.data.menuCode}</span> : null
                                    }
                                </span>
                                : item.title
                        }
                    </span>
                    {showTreeOperation ? <TreeOperation
                        data={item}
                        root={root}
                        onTreeAdd={onTreeAdd}
                        onTreeEdit={onTreeEdit}
                        onTreeDelete={onTreeDelete}
                        isShowAddOperate={isShowAddOperate}
                    /> : null}
                </div>;
                // 禁用方法
                let disableFlag = false;
                if (typeof onDisableAllDeptCall === 'function') {
                    disableFlag = onDisableAllDeptCall(item);
                }else{
                    disableFlag = this.props.disableKeys.indexOf(item.key) > -1;
                }
                return (
                    <TreeNode
                        key={item.key}
                        title={title}
                        id={item.id}
                        dataRef={item}
                        disabled={disableFlag}// 普通用户禁用"全部"部门
                        disableCheckbox={item.disableCheckbox}
                        checkable={(() => isCheckAble && isCheckAble(item))()}  //子节点是否选中
                    >
                        {item.children && item.children.length ? loop(item.children) : ""}
                    </TreeNode>
                );
            });
        };
        $Jq('.tree-wrap .ant-tree.ant-tree-block-node li .ant-tree-node-content-wrapper').css('width', 'auto');
        return (
            <div id="CmTree">
                {
                    // 展示搜索功能
                    showSearch ? <div className="tree-search-wrap"
                                      style={{borderBottom: isSearch === 'isSearch' ? 'none' : '1px solid #ddd'}}>
                        <Search value={this.state.searchValue}
                                placeholder={isSearch === 'isSearch' ? "请输入关键词" : "请输入栏目名称"} onChange={this.onChange}/>
                    </div> : null
                }
                <div className="tree-wrap" style={{paddingRight: '2px'}}>
                    {/*{console.log(selectedKeys,checkedKeys)}*/}
                    <Scrollbars ref={ref => this.treeScrollbars = ref} className="cm-scrollbars" autoHide>
                        <div style={{
                            display: "flex",
                            minWidth: "265px",
                            margin: "0 0 10px 0",
                            justifyContent: 'center'
                        }}>
                            {
                                isShowTree ? <Tree
                                    onExpand={this.onExpand}
                                    expandedKeys={expandedKeys}
                                    autoExpandParent={autoExpandParent}
                                    onSelect={this.onSelect}
                                    blockNode={true}
                                    selectedKeys={selectedKeys}
                                    checkable={checkable}
                                    onCheck={onCheck}
                                    checkedKeys={checkedKeys}
                                    checkStrictly={checkStrictly}
                                    selectable={selectable}
                                >
                                    {loop(treeData, treeData[0])}
                                </Tree> : <Empty style={{marginTop: '55px'}}/>
                            }
                        </div>
                    </Scrollbars>
                    <style>{`
                        // .cm-scrollbars {
                        //     margin: 55px 14px 10px;
                        //     justify-content: center;
                        // }
                        // }
                    `}</style>
                </div>
            </div>
        );
    }

    onSelect = (keys, e) => {
        if (e.selected) {
            this.props.onSelect(keys, e);
        }
    };
    onChange = e => {
        this.setState({
            searchValue: e.target.value
        });

        const expandedKeys = [];
        const {treeData} = this.props;
        let num = 0;
        forEachTree(treeData, node => {
            if (node.children && node.children.length) {
                expandedKeys.push(node.key);
            }
            if ((node.title === e.target.value) || (node.title.indexOf(e.target.value) > -1)) {
                num++;
            }
        });
        // 判断显示空样式
        if (num <= 0) {
            this.setState({isShowTree: false})
        } else {
            this.setState({isShowTree: true})
        }
        this.props.onExpand(expandedKeys);
    };

    onExpand = expandedKeys => {
        this.treeScrollbars && this.treeScrollbars.handleScroll && typeof this.treeScrollbars.handleScroll == 'function' && this.treeScrollbars.handleScroll();
        this.props.onExpand(expandedKeys);
    };

}
